import React from 'react';
import styled from 'styled-components';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface MyPageBreadcrumbProps {
  items: BreadcrumbItem[];
}

const MyPageBreadcrumb: React.FC<MyPageBreadcrumbProps> = ({ items }) => {
  return (
    <BreadcrumbContainer>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <BreadcrumbItem>{item.label}</BreadcrumbItem>
          {index < items.length - 1 && (
            <ChevronIcon>
              <svg width="8" height="16" viewBox="0 0 8 16" fill="none">
                <path 
                  d="M1.73 3.07L6.26 7.6L1.73 12.13" 
                  stroke="rgba(55, 56, 60, 0.61)" 
                  strokeWidth="1.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </ChevronIcon>
          )}
        </React.Fragment>
      ))}
    </BreadcrumbContainer>
  );
};

const BreadcrumbContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const BreadcrumbItem = styled.span`
  color: rgba(55, 56, 60, 0.61);
  font-size: 16px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.09px;
`;

const ChevronIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default MyPageBreadcrumb;
